export default "__VITE_ASSET__Dwd_lixy__"